import { filter, uniqBy } from 'lodash';
import { StringUtil } from 'utils/StringUtil';
import { ProjectSelector } from 'modules/project/selector';
import { NumberUtil } from 'utils/NumberUtil';

const order = (a, b) => {
  return a.detailCard.productName.localeCompare(b.detailCard.productName);
};

const transformParticularProjectList = (projectlist, project_url_slug) => {
  const {
    data,
    data: { device, media_path },
  } = projectlist;
  let flattenProductData = [];
  let projectDataById = [];
  let transformedProductList = [];
  data.products.map(product => {
    product.properties.map(property => {
      flattenProductData.push({ ...product, property });
      // delete product.properties;
    });
  });
  flattenProductData.map(data => {
    if (data.property.project.url_slug === project_url_slug) {
      projectDataById.push(data);
    }
  });
  projectDataById.map(product => {
    const transformedData = {
      device,
      detailCard: {
        id: product.id,
        max_area: NumberUtil.formatNumber(product.max_area),
        min_area: NumberUtil.formatNumber(product.min_area),
        bathrooms: product.number_of_bathrooms,
        bedrooms: product.number_of_bedrooms,
        productName: product.product_name,
        productVersion:
          product.product_version !== null ? product.product_version : '',
        url_slug: product.url_slug,
        images: {
          image_path: media_path,
          image: product.product_list_image1,
          hover_image: product.product_list_image2,
          mobile_image: product.list_mobile_image1,
        },
        content: StringUtil.sliceHtml(product.short_content),
        properties: product.properties,
      },
    };
    transformedProductList.push(transformedData);
  });

  return uniqBy(transformedProductList, 'detailCard.productName').sort(order);
};

const transformProjectDetails = details => {
  let project_amenities = [];
  const media_path = details.media_path;
  const mobile = details.device.mobile;
  const amenity_image = details.projects.amenity_image;
  const amenity_mobile_image = details.projects.amenity_mobile_image;
  const web = details.device.web;
  const thumbnail = details.device.thumbnail;
  const project = {
    id: details.projects.id,
    brochure_campaign_code: details.projects.brochure_campaign_code,
    title: details.projects.project_details[0].project_name,
    project_name:details.projects.display_name ? details.projects.display_name :'',
    description: details.projects.project_details[0].project_description,
    project_list_description:
      details.projects.project_details[0].project_list_description,
    short_description:
      details.projects.project_details[0].project_short_description,
    status: details.projects.project_status.status_name,
    area: details.projects.area.area_name,
    city: details.projects.city.city_name,
    country: details.projects.country.country_name,
    image: details.projects.project_detail_image,
    mobile_image: details.projects.project_detail_mobile_image,
    descriptive_area: details.projects.descriptive_area,
    latitude: details.projects.latitude,
    longitude: details.projects.longitude,
    brochure: details.projects.project_brochure,
    listImageUrl: details.project_list_image,
    thumbNailUrl: `${media_path}${thumbnail}/${details.listImageUrl}`,
    productsDescription:
      details.projects.project_details[0].product_description,
    virtualTours: (details.projects.project_degreeviews || []).map(tour => {
      return {
        id: tour.id,
        view: tour.degree360_view,
      };
    }),
    metaTagSEO: {
      metaTitle: details.projects.meta_title ? details.projects.meta_title : '',
      metaDescription: details.projects.meta_description
        ? details.projects.meta_description
        : '',
      metaKeywords: details.projects.meta_keyword
        ? details.projects.meta_keyword
        : '',
    },
    banner_video: details.projects.header_video,
  };
  details.projects.project_amenities.map((data, index) => {
    const amenities = {
      title: data.amenity.name,
      project_id: data.project_id,
      amenity_id: data.amenity_id,
    };
    project_amenities.push(amenities);
  });
  return {
    project,
    project_amenities,
    media_path: media_path,
    thumbnail: thumbnail,
    mobile: mobile,
    amenity_image: amenity_image,
    amenity_mobile_image: amenity_mobile_image,
    web: web,
  };
};

const transformRecommendedProjects = state => {
  const getCurrentProject = state.projectBrowser.projectDetails;
  const allProjects = ProjectSelector.getProjects(state);
  if (allProjects && allProjects.list) {
    const getCurrentProjectId = getCurrentProject
      ? getCurrentProject.project.id
      : 0;
    const filteredProjects = filter(allProjects.list, function(n) {
      return getCurrentProjectId !== n.id;
    });
    const recommendedList = [];
    if (filteredProjects) {
      filteredProjects.map(project => {
        const list = {
          id: project.id,
          urlSlug: project.urlSlug,
          name: project.name,
          information: StringUtil.sliceHtml(project.description),
          short_description: StringUtil.sliceHtml(project.short_description),
          project_list_description: StringUtil.sliceHtml(
            project.project_list_description
          ),
          image: project.detailImageUrl,
          listImageUrl: project.listImageUrl,
          listMobileImageUrl: project.listMobileImageUrl,
          thumbNailUrl: project.thumbNail,
          location: project.area,
          city: project.city,
        };
        recommendedList.push(list);
      });
      return recommendedList;
    }
    return [];
  }
  return [];
};

// TODO When clicked on Back to all projects  'state.projectBrowser.projectDetails' should get empty. Once done remove the below function
const transformAllPropertiesRecommended = state => {
  const allProjects = ProjectSelector.getProjects(state);
  if (allProjects && allProjects.list) {
    const recommendedList = [];
    allProjects.list.map(project => {
      const list = {
        id: project.id,
        urlSlug: project.urlSlug,
        name: project.name,
        information: StringUtil.sliceHtml(project.description),
        short_description: StringUtil.sliceHtml(project.short_description),
        project_list_description: StringUtil.sliceHtml(
          project.project_list_description
        ),
        image: project.detailImageUrl,
        listImageUrl: project.listImageUrl,
        listMobileImageUrl: project.listMobileImageUrl,
        location: project.area,
        city: project.city,
        thumbNailUrl: project.thumbNail,
        project_name:project.project_name
      };
      recommendedList.push(list);
    });
    return recommendedList;
  }
  return [];
};

export default {
  transformParticularProjectList,
  transformProjectDetails,
  transformRecommendedProjects,
  transformAllPropertiesRecommended,
};
